// extracted by mini-css-extract-plugin
export default {"wrapper":"GJ9GwlcoExcxsMa3fLJj","image":"VAUTHA8JaBsC8cGWUfQX","content":"bidSAhaZTG02og7JGBjP"};